import React, { useEffect, useRef, useState } from 'react'

import { EuiButton, EuiFlexGroup, EuiFlexItem, EuiIcon, EuiLoadingSpinner, EuiPanel, EuiPopoverTitle, EuiSelectable, EuiSpacer, EuiText } from '@elastic/eui'
import { EuiSelectableOption } from '@elastic/eui/src/components/selectable/selectable_option'

export interface INewButton {
  text: string
  onClick?: () => void
}

export interface IAcSearchSelector {
  showSearch?: boolean
  isLoading?: boolean
  newButton?: INewButton
  displayedText: string
  options: EuiSelectableOption[]
  onOptionSelected?: (selectedOption: EuiSelectableOption) => void
}

export const AcSearchSelector: React.FC<IAcSearchSelector> = props => {
  const [showSearch, setShowSearch] = useState(false)
  const componentRef = useRef<any>(null)

  useEffect(() => {
    function handleClickOutside(event: any) {
      if (componentRef.current && !componentRef.current.contains(event.target)) {
        setShowSearch(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const onNewClick = () => {
    setShowSearch(false)
    props.newButton?.onClick?.()
  }

  return (
    <span style={{ width: '100%' }} ref={componentRef}>
      <button
        style={{ width: '100%' }}
        onClick={() => {
          setShowSearch(!showSearch)
        }}>
        <EuiPanel hasBorder={true} hasShadow={false} style={{ paddingLeft: '12px', paddingRight: '8px', paddingTop: '8px', paddingBottom: '8px', textAlign: 'left', border: 'solid 1px rgb(233 233 234)' }} color={'subdued'}>
          <EuiFlexGroup style={{ margin: 0 }}>
            <EuiFlexItem style={{ margin: 0, justifyContent: 'center' }}>
              <EuiText size={'s'}>{props.displayedText}</EuiText>
            </EuiFlexItem>
            <EuiFlexItem grow={false} style={{ margin: 0 }}>
              <EuiIcon type={'arrowDown'} style={{ margin: 'auto 4px' }} size={'m'} />
            </EuiFlexItem>
          </EuiFlexGroup>
        </EuiPanel>
      </button>
      {showSearch && (
        <EuiPanel style={{ width: '100%' }}>
          <EuiSelectable
            searchProps={{ placeholder: 'Find a client' }}
            hidden={showSearch}
            isLoading={props.isLoading}
            searchable={props.showSearch ? true : undefined}
            options={props.options}
            singleSelection='always'
            onChange={items => {
              const selectedItem = items.find(item => item.checked === 'on') as EuiSelectableOption
              if (selectedItem) {
                setShowSearch(false)
                props.onOptionSelected?.(selectedItem)
              }
            }}>
            {(list, search) => (
              <>
                {search && <EuiPopoverTitle>{search}</EuiPopoverTitle>}
                {props.isLoading ? <EuiLoadingSpinner size='m' /> : list}
              </>
            )}
          </EuiSelectable>
          {props.newButton && (
            <>
              <EuiSpacer size={'m'} />
              <EuiButton id='newAcct' size='s' fullWidth onClick={onNewClick}>
                {props.newButton.text}
              </EuiButton>
            </>
          )}
        </EuiPanel>
      )}
    </span>
  )
}
